// Package Imports
import { ScheduleOutlined } from '@ant-design/icons';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
// import PrivateRouteConst from 'core/common/privateRouteConstant';

// const RecalculationQueryResource: ResourceItem = {
//   name: resourceName.recalculationQuery,
//   identifier: PrivateRouteConst.MY_TASK_DASHBOARD,
//   list: `${resourceName.recalculationQuery}`,
//   meta: { label: 'Recalculation', icon: <ScheduleOutlined /> },
// };
const RecalculationQueryResource: ResourceItem = {
  name: resourceName.recalculationQuery,
  identifier: 'allQueryView',
  list: `${resourceName.recalculationQuery}`,
  meta: { label: 'Recalculation', icon: <ScheduleOutlined /> },
};

export default RecalculationQueryResource;
